/*
  Sticky info column (main-product-v2, enable_sticky_info).

  Once the column has scrolled to the bottom of the gallery row it is pinned
  there, so anything that makes it taller grows it upward - a collapsible row
  near the bottom looks like it opens up. When a <details> in the column is
  toggled, stretch the column's wrapper by the same amount so the pinned
  column has room to grow downward, leaving the page where it is. The gallery
  is sticky too, so its wrapper is frozen at its current height first - else
  the taller row gives it room to drift down. Runs before paint, so no jump.
*/
document.querySelectorAll('.product__info-container.product__column-sticky').forEach((column) => {
  const wrapper = column.parentElement;
  const mediaWrapper = wrapper.parentElement.querySelector('.product__media-wrapper');

  column.addEventListener('click', (event) => {
    const summary = event.target.closest('summary');
    if (!summary || !column.contains(summary)) return;
    if (getComputedStyle(column).position !== 'sticky') return;

    const topBefore = summary.getBoundingClientRect().top;
    const columnBefore = column.offsetHeight;
    const wrapperBefore = wrapper.offsetHeight;

    if (mediaWrapper && !mediaWrapper.style.height) {
      mediaWrapper.style.height = `${mediaWrapper.offsetHeight}px`;
      mediaWrapper.style.alignSelf = 'flex-start';
    }

    requestAnimationFrame(() => {
      wrapper.style.minHeight = `${wrapperBefore + column.offsetHeight - columnBefore}px`;

      // Closing a row that was open on load can't shrink the wrapper below the
      // gallery row, so fall back to scrolling for whatever is left over.
      const shift = summary.getBoundingClientRect().top - topBefore;
      if (shift) window.scrollBy({ top: shift, behavior: 'instant' });
    });
  });

  window.addEventListener('resize', () => {
    wrapper.style.minHeight = '';
    if (mediaWrapper) {
      mediaWrapper.style.height = '';
      mediaWrapper.style.alignSelf = '';
    }
  });
});
